import React, {Component, createRef} from "react";
import DataTable from './TableBase';
import { serviceColumns } from './RecordCells';
import {withRouter} from "react-router-dom";
import {apiCall} from "../../helpers/MainHelper";
import Swal from "sweetalert2";

class LastServiceTable extends Component{

    constructor(props) {
        super(props);
        this.tableRef = createRef();
        this.state = {
            pending:true,
            loading:false,
        }

    }
    triggerFetch = (page = 1, size = 10, search = '') => {
        if (this.tableRef.current) {
            this.tableRef.current.fetchData(page, size, search);
        }
    };
    handleServiceDetail = (serviceId) => {
        this.props.history.push(`/service-detail/${serviceId}`);
    }
    handleDelete = async (operationID) => {
        const result = await Swal.fire({
            title: 'Silmek istediğinize emin misiniz?',
            text: "Bu işlem geri alınamaz!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet, sil!',
            cancelButtonText: 'Hayır, iptal et'
        });

        if (result.isConfirmed) {
            try {

                await apiCall('business/operation/delete/'+operationID,'delete',);
                this.triggerFetch();
                Swal.fire(
                    'Silindi!',
                    'Kayıt başarıyla silindi.',
                    'success'
                );
            } catch (error) {
                Swal.fire(
                    'Hata!',
                    'Silme işlemi başarısız oldu.',
                    'error'
                );
            }
        }
    }
    render() {
        const {pending} = this.state;

        const columns = serviceColumns({ motor: false, canView: true, canDelete: true, onView: row => this.handleServiceDetail(row.id), onDelete: row => this.handleDelete(row.id) });

        return (
            <DataTable
                ref={this.tableRef}
                dataEndpoint={"business/operation/get-last"}
                columns={columns}
                onRowClicked={row => this.handleServiceDetail(row.id)}
                progressPending={pending}>
            </DataTable>
        )
    }

}
export default withRouter(LastServiceTable);
